/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-08-25 19:59:37
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-08-30 16:35:54
 */
import * as types from '../../../mutation-types';
export default {
	[types.SUB_MEUNS_LIST](state, list) {
		if (Array.isArray(list)) {
			state.vuex_subMenuList = list;
		}
	},
	[types.MEUNS_LIST](state, list) {
		if (Array.isArray(list)) {
			state.vuex_menuList = list;
			state.vuex_isshopurl = !!list.find(item => item.path == '/cooperativeShop');
		}
	},
	[types.CHANGE_READY](state, val) {
		state.vuex_ready = val;
	},
	[types.PERMISSION_INFO](state, val) {
		state.vuex_permissionInfo = val;
	},
	[types.BIND_ROLES](state, list) {
		state.vuex_roles = list;
		localStorage.setItem('vuex_roles', JSON.stringify(list));
	},
	[types.SET_DICT_DATAS](state, dictDatas) {
		state.vuex_dictDatas = dictDatas;
	},
};
